export const  templateMock = [
    {
      consignmentId: 305115,
      createdDate: {
        year: 1403,
        month: 8,
        day: 26,
        hour: '09',
        minute: '29',
      },
      cprNumber: '1000043951718',
      fkLabelId: 684958,
      receiverProspectId: 307508,
      contentName: null,
      consignmentType: '1',
      consignmentTypeName: 'بسته',
      contentType: '1',
      contentTypeName: 'غیر اسناد و مدارک',
      fkOrderId: 44874,
      declarativeWidth: 15,
      width: 15,
      declarativeHeight: 10,
      height: 10,
      length: 20,
      declarativeLength: 20,
      declarativeValue: 1000000,
      declarativeVolume: 200,
      volume: 200,
      weight: 1,
      declarativeWeight: 1,
      costOfGoods: null,
      needToReceiveCostOfGoods: false,
      needToPack: null,
      packageId: 2,
      packageName: 'سایز 2',
      receiverAddressId: 322557,
      thirdPartyOrderId: null,
      thirdPartyCprNum: null,
      thirdPartySourceCityCode: null,
      currentHub: null,
      deliveryHubId: 2,
      pickupHubId: 2,
      originHubId: null,
      receiverProspectName: 'نام گیرنده',
      receiverProspectMobile: '099999999',
      senderName: 'نام فرستنده',
      senderMobile: '099999999',
      senderNationalCode: null,
      pkInvoiceDetailId: 465934,
      grossPrice: 440000,
      netPrice: 400000,
      valueAddedTax: 40000,
      receiverAddress: 'آدرس گیرنده',
      receiverCityId: 1126,
      receiverCityName: 'تهران',
      receiverState: {
        id: 30,
        text: 'تهران',
      },
      senderCityId: 1126,
      printIndex: 1,
      senderCityName: 'تهران',
      trackingCode: 'order140382656433',
      orderRegistrationHub: null,
      easyOrder: true,
      senderAddressId: 112,
      serviceList: [
        {
          id: 344294,
          serviceName: 'ترب 2',
          serviceType: 0,
          price: 400000,
        },
      ],
      nationalCode: '1112223334',
      paymentBy: 'SENDER',
      customerCprNumber: null,
      selectStatus: {
        id: 0,
        text: 'پیش نویس',
      },
      selectInvoiceStatus: {
        id: 1,
        text: 'در انتظار پرداخت',
      },
      cnDirection: 0,
      senderAddress: 'آدرس فرستنده',
      nationalID: '14010625800',
    },
  ];
  
  export const datinNumber = '989125339196';

  export const customPageSize=1500